import styled, { css, keyframes, createGlobalStyle } from 'styled-components';

import { EDITOR_SIDEBAR_WIDTH, WORKSPACE_TOPBAR_HEIGHT } from 'common/styles/variables';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    PADDING_PROPERTIES,
    ALIGNMENT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

const appearAnimation = keyframes`
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
`;

const slideUp = keyframes`
0% {
    transform: translateY(2rem);
}
100% {
    transform: translateY(0);
}
`;

export const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    overflow: auto;
    padding: 4rem;
    animation: ${appearAnimation} linear 250ms forwards;
    background-color: rgba(0, 0, 0, 0.5); // eslint-disable-line splash/sui-colors-only

    ${mediaMaxWidth.large`
        padding: 3rem 1rem;
    `};

    z-index: 1;
`;

export const ModalWrapper = styled.div`
    max-width: 650px;
    margin: 0 auto;
    background-color: ${(props) => props.$backgroundColor};
    position: relative;
    display: flex;

    ${PADDING_PROPERTIES}
    ${ALIGNMENT_PROPERTIES}
    gap: ${(props) => props.$gap}px;

    animation: ${slideUp} linear 250ms forwards;

    ${mediaMaxWidth.medium`
        padding: 1.5rem;
    `};

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const CloseButtonContainer = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    border: none;
    padding: 2rem;
    color: ${(props) => props.$color};
    cursor: pointer;
    transition: color 100ms ease;
    background-color: transparent;
    outline-style: none;

    &:hover {
        color: ${(props) => props.$colorHover};
    }

    &:focus {
        outline-style: auto;
    }
`;

const editorCss = css`
    top: ${WORKSPACE_TOPBAR_HEIGHT};
    width: calc(100% - ${EDITOR_SIDEBAR_WIDTH});
`;

export const ModalGlobalStyles = createGlobalStyle`
    .cms-engine-modal {
        ${(props) => (props.isEditing ? editorCss : '')}
    }
`;
